module.exports = __webpack_public_path__ + "img/rank.bd06c34d.svg";